import React from 'react'
import { Button, Tooltip } from 'antd'
import {
	FilePdfOutlined,
	DownloadOutlined,
	SyncOutlined,
	LoadingOutlined,
	CloseCircleOutlined,
	HistoryOutlined,
} from '@ant-design/icons'
import PropTypes from 'prop-types'

import styles from './index.module.scss'

const STATUS_CONFIG = {
	processing: {
		background: styles.processingBackground,
		icon: styles.processingIcon,
		tagClass: styles.statusProcessing,
		label: 'Processando',
		TagIcon: LoadingOutlined,
	},
	failed: {
		background: styles.errorBackground,
		icon: styles.errorIcon,
		tagClass: styles.statusFailed,
		label: 'Falhou',
		TagIcon: CloseCircleOutlined,
	},
}

const AttachmentPreview = ({
	attachment,
	onDownload,
	loading,
	hasError,
	status,
	onRetry = () => {},
	onCheckStatus,
}) => {
	const statusConfig = status ? STATUS_CONFIG[status] : null
	const isFailed = hasError || status === 'failed'
	const isProcessing = status === 'processing'

	const iconBg = statusConfig
		? statusConfig.background
		: isFailed
			? styles.errorBackground
			: styles.iconWrapper

	const iconClass = statusConfig
		? statusConfig.icon
		: isFailed
			? styles.errorIcon
			: styles.fileIcon

	const renderAction = () => {
		if (isFailed) {
			return (
				<Tooltip title="Reprocessar" overlayInnerStyle={{ borderRadius: 4 }}>
					<Button
						type="text"
						icon={
							<SyncOutlined
								className={loading ? styles.loadingIcon : styles.downloadIcon}
							/>
						}
						disabled={loading}
						onClick={onRetry}
					/>
				</Tooltip>
			)
		}

		if (isProcessing) {
			return (
				<Tooltip
					title="Verificar status"
					overlayInnerStyle={{ borderRadius: 4 }}>
					<Button
						type="text"
						icon={
							<HistoryOutlined
								className={loading ? styles.loadingIcon : styles.downloadIcon}
							/>
						}
						disabled={loading}
						onClick={onCheckStatus}
					/>
				</Tooltip>
			)
		}

		return (
			<Tooltip title="Baixar" overlayInnerStyle={{ borderRadius: 4 }}>
				<Button
					type="text"
					icon={<DownloadOutlined className={styles.downloadIcon} />}
					disabled={loading}
					onClick={onDownload}
				/>
			</Tooltip>
		)
	}

	return (
		<li className={styles.attachmentItem}>
			<div className={styles.fileInfo}>
				<div className={iconBg}>
					<FilePdfOutlined className={iconClass} />
				</div>
				<div className={styles.fileDetails}>
					<p className={styles.fileName} title={attachment.original_name}>
						{attachment.original_name}
					</p>
					<span className={styles.fileMeta}>
						{attachment.file_size ? `${attachment.file_size} | ` : ''}
						{attachment?.responsible ? attachment.responsible : ''}
					</span>
					{statusConfig && (
						<span className={`${styles.statusTag} ${statusConfig.tagClass}`}>
							<statusConfig.TagIcon
								spin={isProcessing}
								style={{ fontSize: 10 }}
							/>
							{statusConfig.label}
						</span>
					)}
				</div>
			</div>
			{renderAction()}
		</li>
	)
}

AttachmentPreview.propTypes = {
	attachment: PropTypes.shape({
		id: PropTypes.string,
		original_name: PropTypes.string,
		file_size: PropTypes.string,
		created_at: PropTypes.string,
		responsible: PropTypes.string,
	}),
	loading: PropTypes.bool,
	onDownload: PropTypes.func,
	hasError: PropTypes.bool,
	status: PropTypes.oneOf(['processing', 'completed', 'failed']),
	onRetry: PropTypes.func,
	onCheckStatus: PropTypes.func,
}

export default AttachmentPreview
